import { useState, useEffect, useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useListarProdutos } from "services/api/Common_Produtos/listar-produtos";
import { usePutAlterarProdutosInteresse } from "services/api/Common_Produtos/alterar-produtos-interesse";
import MaterialUI from "../../../../material-UI";
import SelectAutoCompleteMultipleG from "../../../SelectAutoCompleteMultipleG";
import * as S from "./styles";

interface Props {
  onClose: Function;
  open: boolean;
  anchorLeadCorretor?: string;
  produtosAtuais?: Array<{ id: string; nome: string }>;
  refetch: any;
}

export function ProdutosModal(props: Props) {
  const { codigoRegional365 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const { data: produtos, isLoading: isLoadingProdutos } = useListarProdutos({
    codigoRegional365: codigoRegional365 || "",
    enabled: props.open,
  });

  const [produtosSelecionados, setProdutosSelecionados] = useState<
    Array<{ label: string; value: string }>
  >(
    props.produtosAtuais?.map((p) => ({
      label: p.nome,
      value: p.id,
    })) || []
  );

  const { mutate: mutateAlterar, isLoading: isLoadingAlterar } =
    usePutAlterarProdutosInteresse();

  useEffect(() => {
    if (props.produtosAtuais) {
      setProdutosSelecionados(
        props.produtosAtuais.map((p) => ({
          label: p.nome,
          value: p.id,
        }))
      );
    }
  }, [props.produtosAtuais, props.open]);

  const produtosOptions = useMemo(() => {
    return (
      produtos?.map((item: any) => ({
        label: item?.nome || "",
        value: item?.id || "",
      })) || []
    );
  }, [produtos]);

  const handleSubmit = () => {
    if (props.anchorLeadCorretor) {
      const idsEmpreendimentos365 = produtosSelecionados.map((p) => p.value);
      mutateAlterar(
        {
          idLeadCorretor365: props.anchorLeadCorretor,
          idsEmpreendimentos365,
        },
        {
          onSuccess: (responseData: any) => {
            props.refetch(responseData?.data);
            props.onClose();
          },
        }
      );
    }
  };

  const handleChangeProdutos = (
    event: React.SyntheticEvent,
    value: Array<{ label: string; value: string }> | null
  ) => {
    setProdutosSelecionados(value || []);
  };

  return (
    <S.Container>
      {isLoadingProdutos ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: "20px" }}
        >
          <MaterialUI.CircularProgress />
        </div>
      ) : (
        <SelectAutoCompleteMultipleG
          borderRadius="8px"
          data={produtosOptions}
          label="Produtos"
          value={produtosSelecionados}
          onChange={handleChangeProdutos}
          placeholder="Selecione os produtos"
          isMultiple
        />
      )}
      <S.SpaceY space={32} />
      <S.Buttons>
        <button
          className="secondary"
          type="button"
          onClick={() => {
            props.onClose();
          }}
        >
          Cancelar
        </button>
        <button
          className="primary"
          type="button"
          disabled={isLoadingAlterar}
          onClick={() => {
            handleSubmit();
          }}
        >
          {isLoadingAlterar ? (
            <MaterialUI.CircularProgress style={{ color: "#fff" }} size={22} />
          ) : (
            "Confirmar"
          )}
        </button>
      </S.Buttons>
    </S.Container>
  );
}
